<template>
  <div class="app-detail">
    <div class="pic">
      <div class="title">上传照片<span>(最多9张图,相机占内存大,建议相册选择)</span></div>
      <div class="pic-box">
        <van-uploader :before-read="beforeReadImg" :after-read="afterRead" v-model="picList" :max-count="9" accept="*">
          <div class="add-btn">
            <img src="../../assets/icon/image_add.png">
            <div class="add-btn-tip">上传照片</div>
          </div>
        </van-uploader>
      </div>
    </div>
    <div class="pic" v-if="!isIos">
      <div class="title">上传视频<span>(仅支持mp4格式视频上传,30秒以内)</span></div>
      <div class="pic-box">
        <van-uploader :before-read="beforeReadVideo" :after-read="afterRead" :max-count="1" v-if="videoList.length==0" accept="*">
          <div class="add-btn">
            <img src="../../assets/icon/upload_video.png">
            <div class="add-btn-tip">上传视频</div>
          </div>
        </van-uploader>
        <div class="video-box" v-if="videoList.length>0">
          <div class="delete-video" v-on:click="deleteVideo"><img src="../../assets/icon/ic_close_video.png"></div>
          <video width="76%" height="240" controls id="mvideo" style="background-color:#f0f3f5">
            <source :src="videoList[0].url" type="video/mp4">
          </video>
        </div>
      </div>
    </div>
    <div class="pic" v-if="!isIos">
      <div class="title">上传录音<span>(仅支持mp3/m4a格式音频上传,600秒以内)</span></div>
      <div class="pic-box">
        <van-uploader :before-read="beforeReadAudio" :after-read="afterRead" accept="*">
          <div class="add-btn">
            <img src="../../assets/icon/audio_add.png">
            <div class="add-btn-tip">上传录音</div>
          </div>
        </van-uploader>
      </div>
      <div style="width:100%;position:relative" v-for="(item ,i) in audioList" :key="i">
        <audio controls style="display:block;padding-bottom:10px;width:90%;" ref='audio'>
          <source :src="item.url" type="audio/ogg">
          <source :src="item.url" type="audio/mpeg">
          您的浏览器不支持 audio 元素。
        </audio>
        <div class="delete-audio" @click="deleteAudio(i)"><img src="../../assets/icon/ic_close_video.png"></div>
      </div>
    </div>
    <div class="btn-box" @click="backToMiniProgram"><button>保存</button></div>
    <van-loading size="40px" text-size="14" vertical color="#fff" type="spinner" class="loading" v-if="isLoading" style="color:#fff;background-color:rgba(0,0,0,.6)">上传中...{{complete}}</van-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import uploadHttp from '@/utils/picOnly';
import api from '@/utils/api'
import { getToken, isIos } from '@/utils/common'
import config from '@/utils/config'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      picList: [
      ],
      audioList: [
      ],
      videoList: [],
      fileType: '',
      isLoading: false,
      res: '',
      access_token: '',
      fname: '',
      bs64: '',
      deleteIndex: -1,
      aaa: '未知',
      uploadMessage: '',
      isIos: true
    }
  },
  created() {
    this.isIos = isIos()
  },
  mounted() {
    config.TOKEN = this.$route.query.token;
    localStorage.setItem("token", this.$route.query.token);
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  computed: {
    ...mapGetters({
      complete: 'getComplete'
    })
  },
  methods: {
    backToMiniProgram() {
      var self = this;
      var list = this.$refs.audio || [];
      var audioList = this.audioList, videoList = this.videoList;
      // 判断时间长度
      if (list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].duration > 600) {
            Toast('录音时长不能超过600秒，请删除过长录音');
            return false;
          }
          audioList[i].duration = list[i].duration
        }
      }
      if (videoList.length > 0) {
        var myVid = document.getElementById("mvideo");
        // if (myVid.duration > 30) {
        //   Toast('上传视频不能超过30秒');
        //   return false;
        // }
        if (!myVid.duration) {
          Toast('未获取到视频时长，请点击播放视频，再尝试保存');
          return false;
        }
      }
      wx.miniProgram.postMessage({
        data: {
          picList: self.picList,
          audioList: audioList,
          videoList: videoList
        }
      })
      wx.miniProgram.navigateBack({
        delta: 1
      })

    },
    deleteAudio(index) {
      this.audioList.splice(index, 1)
      var list = this.$refs.audio;
      if (list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          list[i].load()
        }
      }
    },
    deleteVideo() {
      this.videoList = []
    },
    async afterRead(file) {
      var self = this;
      var type = this.fileType, url
      let formData = new window.FormData();
      if (type.indexOf('png') != -1 || type.indexOf('jpg') != -1 || type.indexOf('jpeg') != -1) {
        compress(file.content, 750, 0.6).then((res) => {
          file.file = res
        })
      }
      formData.append('file', file.file);
      formData.append("access_token", getToken())
      if (type.indexOf('png') != -1 || type.indexOf('jpg') != -1 || type.indexOf('jpeg') != -1) {
        this.picList.pop();
        url = api.checkin.uploadPic
      } else if (type.indexOf('wav') != -1 || type.indexOf('mp3') != -1 || type.indexOf('MP3') != -1|| type.indexOf('m4a') != -1 || type.indexOf('aac') != -1) {
        url = api.checkin.uploadAudio
      } else if (type.indexOf('video') != -1) {
        url = api.checkin.uploadVideo
      }else if (type.indexOf('audio') != -1) {
        url = api.checkin.uploadAudio
      }
        
      try {
        // uploadHttp
        uploadHttp.post(url, formData)
          .then(res => {
            self.isLoading = false;
            self.$store.state.complete = 0;
            if (res.sta == 0) {
              var url = res.data.url;
              // if (url.indexOf('MOV') != -1) {
              //   Toast('暂不支持苹果MOV视频文件格式，仅支持摄像头拍摄')
              //   return;
              // }
              if (type.indexOf('png') != -1 || type.indexOf('jpg') != -1 || type.indexOf('jpeg') != -1) {
                self.picList.push({ url: res.data.urls[0] })
              } else if (type.indexOf('wav') != -1 || type.indexOf('mp3') != -1 || type.indexOf('MP3') != -1|| type.indexOf('m4a') != -1 || type.indexOf('aac') != -1) {
                self.audioList.push({ url: url })
              } else if (type.indexOf('video') != -1) {
                self.videoList.push({ url: url, picUrl: res.data.thumb ? res.data.thumb : "" })
              }else if (type.indexOf('audio') != -1) {
                self.audioList.push({ url: url })
              }
            } else if (res.sta == -500) {
              Toast('登录过期，请返回小程序首页重新进入')
            }
          })
      } catch (e) {
        console.log(e);
      }
    },
    beforeReadImg(file) {
      console.log(file.type)
      this.isLoading = true
      if (this.picList.length > 8) {
        this.isLoading = false
        Toast('最多九张图片');
        return false;
      }
      this.fileType = file.type
      let type = file.type
      if (type.indexOf('png') == -1 && type.indexOf('jpg') == -1 && type.indexOf('jpeg') == -1) {
        this.isLoading = false
        Toast('请上传正确格式图片，只能是png/jpg/jpeg格式');
        return false;
      }
      return true;
    },
    beforeReadAudio(file) {
      this.isLoading = true
      this.fileType = file.type;
      if (this.audioList.length > 8) {
        this.isLoading = false
        Toast('最多九段录音');
        return false;
      }
      // let type = file.type
      // if (type.indexOf('wav') == -1 && type.indexOf('mp3') == -1 && type.indexOf('MP3') == -1 && type.indexOf('m4a') == -1 && type.indexOf('aac') == -1) {
      //   this.isLoading = false
      //   Toast(type + '不正确，请上传 mp3 格式录音');
      //   return false;
      // }
      return true;
    },
    beforeReadVideo(file) {
      this.isLoading = true
      this.fileType = file.type;
      let type = file.type
      if (type.indexOf('video') == -1) {
        this.isLoading = false
        Toast('请上传视频格式文件');
        return false;
      }
      // if (type.indexOf('MOV') == -1 || type.indexOf('mov') == -1) {
      //   this.isLoading = false
      //   Toast('暂不支持苹果MOV文件格式，仅支持摄像头拍摄');
      //   return false;
      // }
      return true;
    },
  }
}

function compress(base64String, w, quality) {
  var getMimeType = function (urlData) {
    var arr = urlData.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    // return mime.replace("image/", "");
    return mime;
  };
  var newImage = new Image();
  var imgWidth, imgHeight;
  var promise = new Promise(resolve => newImage.onload = resolve);
  newImage.src = base64String;
  return promise.then(() => {
    imgWidth = newImage.width;
    imgHeight = newImage.height;
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = w * imgHeight / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = w * imgWidth / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
    var base64 = canvas.toDataURL(getMimeType(base64String), quality);
    return base64;
  });
}

</script>



<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}

.app-detail {
  color: #666666;
  font-size: rem(14);
  .pic {
    background-color: #fff;
    padding: 0 rem(15);
    margin-bottom: rem(10);
    .delete-audio {
      width: rem(18);
      height: rem(18);
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      height: rem(47);
      line-height: rem(47);
      color: #666;
      font-size: rem(15);
      span {
        font-size: rem(13);
      }
    }
    .pic-box {
      overflow: hidden;
      /deep/ .van-uploader__preview-image {
        width: rem(58);
        height: rem(58);
      }
      /deep/ .van-uploader__preview {
        width: rem(58);
        height: rem(58);
      }
      /deep/ .van-uploader__file {
        width: rem(58);
        height: rem(58);
      }
      .add-btn {
        width: rem(58);
        height: rem(58);
        border-radius: rem(5);
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        font-size: rem(12);
        border: 1px solid #eee;
        margin-bottom: rem(15);
        img {
          width: rem(25);
          height: rem(25);
          padding-top: rem(9);
        }
        .add-btn-tip {
          padding-bottom: rem(7);
        }
      }
    }
  }
  .video-box {
    position: relative;
    .delete-video {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      padding: rem(10);
      padding-top: 0;
      img {
        width: rem(20);
        height: rem(20);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pic/pic.vue